import { c as _c } from "react-compiler-runtime";
import React from "react";
import { Keyboard, Label, ListBoxItem as AriaListBoxItem, MenuItem as AriaMenuItem, Provider } from "react-aria-components";
import { icon } from "../../icon.css.js";
import { Check } from "../../icons/line.js";
import { Checkbox } from "../Checkbox.js";
import { AvatarContext } from "./AvatarContext.js";
import * as styles from "./DropdownItem.css.js";
import { DropdownItemContext } from "./DropdownItemContext.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Item(t0) {
  const $ = _c(28);
  const {
    left,
    secondary,
    children,
    keyboardShortcut,
    isSelected: t1,
    textValue
  } = t0;
  const isSelected = t1 === undefined ? false : t1;
  const {
    size: t2,
    selectionMode: t3
  } = React.useContext(DropdownItemContext);
  const size = t2 === undefined ? "m" : t2;
  const selectionMode = t3 === undefined ? "single" : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [[AvatarContext, {
      size: "xxs",
      isInteractive: false,
      tooltip: false
    }]];
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== isSelected || $[2] !== selectionMode) {
    t5 = selectionMode === "multiple" ? /*#__PURE__*/_jsx("div", {
      className: styles.checkbox,
      children: /*#__PURE__*/_jsx(Checkbox, {
        isSelected: isSelected
      })
    }) : null;
    $[1] = isSelected;
    $[2] = selectionMode;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== left) {
    t6 = left == null ? null : /*#__PURE__*/_jsx("div", {
      className: styles.menuItemIcon,
      children: typeof left === "function" ? /*#__PURE__*/React.createElement(left, {
        className: icon({
          size: "s"
        })
      }) : left
    });
    $[4] = left;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== size) {
    t7 = styles.itemText({
      size
    });
    $[6] = size;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== children || $[9] !== t7 || $[10] !== textValue) {
    t8 = /*#__PURE__*/_jsx(Label, {
      slot: "label",
      title: textValue,
      className: t7,
      children: children
    });
    $[8] = children;
    $[9] = t7;
    $[10] = textValue;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== secondary || $[13] !== size) {
    t9 = secondary == null ? null : /*#__PURE__*/_jsx(Label, {
      slot: "description",
      className: styles.itemTextSecondary({
        size
      }),
      children: secondary
    });
    $[12] = secondary;
    $[13] = size;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== keyboardShortcut || $[16] !== size) {
    t10 = keyboardShortcut == null ? null : /*#__PURE__*/_jsx(Keyboard, {
      className: styles.keyboardShortcut({
        size
      }),
      children: keyboardShortcut
    });
    $[15] = keyboardShortcut;
    $[16] = size;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== isSelected || $[19] !== selectionMode) {
    t11 = isSelected && selectionMode === "single" && /*#__PURE__*/_jsx(Check, {
      className: styles.checkedIcon
    });
    $[18] = isSelected;
    $[19] = selectionMode;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t5 || $[24] !== t6 || $[25] !== t8 || $[26] !== t9) {
    t12 = /*#__PURE__*/_jsxs(Provider, {
      values: t4,
      children: [t5, t6, t8, t9, t10, t11]
    });
    $[21] = t10;
    $[22] = t11;
    $[23] = t5;
    $[24] = t6;
    $[25] = t8;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
}
export function DropdownItem(t0) {
  const $ = _c(20);
  let children;
  let color;
  let keyboardShortcut;
  let left;
  let props;
  let secondary;
  if ($[0] !== t0) {
    ({
      color,
      children,
      left,
      secondary,
      keyboardShortcut,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = color;
    $[3] = keyboardShortcut;
    $[4] = left;
    $[5] = props;
    $[6] = secondary;
  } else {
    children = $[1];
    color = $[2];
    keyboardShortcut = $[3];
    left = $[4];
    props = $[5];
    secondary = $[6];
  }
  const {
    size: t1
  } = React.useContext(DropdownItemContext);
  const size = t1 === undefined ? "m" : t1;
  let t2;
  if ($[7] !== color || $[8] !== size) {
    t2 = styles.menuItem({
      size,
      color
    });
    $[7] = color;
    $[8] = size;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== color || $[12] !== keyboardShortcut || $[13] !== left || $[14] !== secondary) {
    t3 = /*#__PURE__*/_jsx(Item, {
      color: color,
      left: left,
      secondary: secondary,
      keyboardShortcut: keyboardShortcut,
      children: children
    });
    $[10] = children;
    $[11] = color;
    $[12] = keyboardShortcut;
    $[13] = left;
    $[14] = secondary;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== props || $[17] !== t2 || $[18] !== t3) {
    t4 = /*#__PURE__*/_jsx(AriaMenuItem, {
      className: t2,
      ...props,
      children: t3
    });
    $[16] = props;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}
const BaseListBoxItem = (t0, ref) => {
  const $ = _c(16);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const {
    size: t1
  } = React.useContext(DropdownItemContext);
  const size = t1 === undefined ? "m" : t1;
  const left = props.left ?? props.icon;
  let t2;
  if ($[3] !== size) {
    t2 = styles.menuItem({
      size
    });
    $[3] = size;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== left || $[7] !== props.secondary || $[8] !== props.textValue) {
    t3 = t4 => {
      const {
        isSelected
      } = t4;
      return /*#__PURE__*/_jsx(Item, {
        isSelected: isSelected,
        left: left,
        secondary: props.secondary,
        textValue: props.textValue ?? children,
        children: children
      });
    };
    $[5] = children;
    $[6] = left;
    $[7] = props.secondary;
    $[8] = props.textValue;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== children || $[11] !== props || $[12] !== ref || $[13] !== t2 || $[14] !== t3) {
    t4 = /*#__PURE__*/_jsx(AriaListBoxItem, {
      textValue: children,
      ...props,
      className: t2,
      ref: ref,
      children: t3
    });
    $[10] = children;
    $[11] = props;
    $[12] = ref;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export const ListBoxItem = /*#__PURE__*/React.forwardRef(BaseListBoxItem);
//# sourceMappingURL=DropdownItem.js.map